import Auth from "@aws-amplify/auth";
import * as Backbone from "backbone";
import * as $ from "jquery";
import * as _ from "lodash";
import { AppRegistry } from "./apps/AppRegistry";
import { BaseAppView } from "./apps/_BaseAppViews";
import { AppCollection } from "./collections/Apps";
import { BrandCollection } from "./collections/Brands";
import { DashboardChannelCollection } from "./collections/DashboardChannels";
import { DashboardCollection } from "./collections/Dashboards";
import { InstallCollection } from "./collections/Installs";
import { OrganizationCollection } from "./collections/Organizations";
import { PermissionCollection } from "./collections/Permissions";
import { Intercom } from "./common/intercom";
import { CurrentUser } from "./models/CurrentUser";
import { AuthMigrateView } from "./views/AuthMigrateView";
import { FooterView } from "./views/Footer";
import { ForgotPasswordView } from "./views/ForgotPasswordView";
import { InvitationAcceptedView } from "./views/InvitationAcceptedView";
import { LoginView } from "./views/LoginView";
import { PermissionDeniedView } from "./views/PermissionDeniedView";
import { SetPasswordView } from "./views/SetPasswordView";
import { BaseView } from "./views/_BaseViews";
import { AccountView } from "./views/account/AccountView";
import { EditOrganizationsView } from "./views/admin/EditOrganizationsView";
import { DashboardView } from "./views/dashboard/DashboardView";
import { AddDashboardView } from "./views/dashboard/addDashboardView";
import { AddToolsView } from "./views/modals/tools/AddToolsView";
import { NavView } from "./views/nav/NavView";
import { SidepanelView } from "./views/nav/SidepanelView";
import { ReportsView } from "./views/reports/ReportsView";
import { DailyReportsView } from "./views/reports/dailyReports/DailyReportsView";
import { EditReportsView } from "./views/reports/editReports/EditReportsView";
import { SettingsView } from "./views/settings/SettingsView";
import { StatusView } from "./views/status/StatusView";

require("bootstrap-notify");

declare const CONFIG;
declare var App;

export class AppRouter extends Backbone.Router {
    navView = null;
    sidepanelView = null;
    footerView = null;

    lastView: BaseView = null;

    appCollection: AppCollection;
    appRegistry: AppRegistry;
    brandCollection: BrandCollection;
    dashboardCollection: DashboardCollection;
    dashboardChannelCollection: DashboardChannelCollection;
    installCollection: InstallCollection;
    organizationCollection: OrganizationCollection;
    permissionCollection: PermissionCollection;

    collectionsLoaded = false;
    navigationRendered = false;
    currentUser = null;
    jwtRefreshInterval = null;

    spinnerTemplate = _.template(require("./templates/spinner.html"));

    constructor() {
        super({
            routes: {
                "status/": "showStatus",
                "status/:orgId": "showStatus",
                "status/:orgId/:installId": "showStatus",
                "status/:orgId/:installId/:moduleId": "showStatus",

                "dashboard/": "showDashboard",
                "dashboard/:dashboardId": "showDashboard",

                "settings/": "showSettings",
                "settings/:category": "showSettings",
                "settings/:category/:orgId": "showSettings",
                "settings/:category/:orgId/:installId": "showSettings",
                "settings/:category/:orgId/:installId/:moduleId": "showSettings",

                "account/": "showAccount",
                "account/:orgId": "showAccount",
                "account/:orgId/:accountCategory": "showAccount",
                "account/:orgId/:accountCategory/:itemId": "showAccount",
                "account/:orgId/:accountCategory/:itemId/:detail": "showAccount",
                "account/:orgId/:accountCategory/:itemId/:detail/:subDetail": "showAccount",
                "account/:orgId/:accountCategory/:itemId/:detail/:subDetail/:subDetailId": "showAccount",

                "reports/": "showReports",
                "reports/:orgId": "showReports",
                "reports/:orgId/:reportId/edit": "showEditReports",
                "reports/:orgId/:reportId/edit/:reportsEditCategory": "showEditReports",

                "dailyReports/:orgId": "showDailyReports",

                "addTool/:toolType": "showAddTools",
                "addDashboard": "showAddDashboard",

                "profile/": "profileRouteAlias",

                "authmigrate/:userId/:token": "showAuthMigrate",
                "forgotPassword/": "showForgotPassword",
                "forgotPassword/:userId/:token": "showForgotPassword",
                "logout": "logout",

                "joined/:groupName": "showJoinedGroup",
                "setPassword/:id/:token": "showJoinedOrganization",

                // Admin
                "admin": "showEditOrganizations",

                "landing/:orgId": "landing",
                "": "root", // Empty route
                "*actions": "defaultAction", // Fallback for all others

            },
        });

        this.appCollection = new AppCollection();
        this.brandCollection = new BrandCollection();
        this.dashboardCollection = new DashboardCollection();
        this.dashboardChannelCollection = new DashboardChannelCollection();
        this.installCollection = new InstallCollection();
        this.organizationCollection = new OrganizationCollection();
        this.permissionCollection = new PermissionCollection();

        this.appCollection.on("error", this.onCollectionLoadFailure, this);
        this.dashboardCollection.on("error", this.onCollectionLoadFailure, this);
        this.dashboardChannelCollection.on("error", this.onCollectionLoadFailure, this);
        this.installCollection.on("error", this.onCollectionLoadFailure, this);
        this.organizationCollection.on("error", this.onCollectionLoadFailure, this);
        this.permissionCollection.on("error", this.onCollectionLoadFailure, this);

        var appVersionCheckInterval = null;
        var appVersionDifferenceDetected = false; // Was the app version different at least once
        var showAppVersionTriggered = false; // Are we already showing the app version updated bar
        var numberOfLastConsistentAppVersions = 0; // How many times was the app version consistent in the last request

        // Set up handler to send JWT with every request
        $(document).ajaxSend(function (event, jqXHR) {
            var prefix = `CognitoIdentityServiceProvider.${CONFIG.cognito.userPoolWebClientId}`;
            var user = localStorage.getItem(`${prefix}.LastAuthUser`);
            var token = localStorage.getItem(`${prefix}.${user}.idToken`);
            jqXHR.setRequestHeader("Authorization", `Bearer ${token}`);
        });

        $(document).ajaxSuccess((event, jqXHR) => {
            // Check if the application version version has updated, and show a message if it did
            var appVersion = jqXHR.getResponseHeader("X-App-Version");
            if (!App.Version) App.Version = appVersion;

            if (appVersion && App.Version !== appVersion) {
                appVersionDifferenceDetected = true;
                numberOfLastConsistentAppVersions = 0;
                App.Version = appVersion;

                // Make sure the last 10 requests had the same app version. We're doing this to assure
                // the deployment has been completed
                if (!appVersionCheckInterval && !showAppVersionTriggered) {
                    appVersionCheckInterval = setInterval(() => {
                        if (numberOfLastConsistentAppVersions >= 10 && !showAppVersionTriggered) {
                            showAppVersionTriggered = true;

                            var brand = this.brandCollection.getBrand();
                            (<any>$).notify(
                                {
                                    icon: "fa fa-info-circle",
                                    title: brand.get("name") + " has been updated",
                                    message: "Please refresh your browser or click here",
                                    url: "javascript:location.reload(true)",
                                    target: "_self",
                                },
                                {
                                    delay: 0,
                                    offset: {
                                        x: 20,
                                        y: 60,
                                    },
                                }
                            );
                        } else if (showAppVersionTriggered) {
                            clearInterval(appVersionCheckInterval);
                        }
                    }, 1000);
                }
            } else if (appVersionDifferenceDetected) {
                numberOfLastConsistentAppVersions++;
            }
        });

        $(document).ajaxError((event, jqxhr) => {
            if (jqxhr.status == 403) {
                if (jqxhr.responseJSON.code === "INACTIVETENANT") {
                    alert(
                        "" +
                            "Your Organization is no longer active. \n" +
                            "Inactive Organization(s): " +
                            jqxhr.responseJSON.organizationNames.join(", ") +
                            "\n\n" +
                            "Please contact an administrator about the status of your organization."
                    );
                } else {
                    alert(
                        "" +
                            "An Error occurred. You do not have the required permissions to perform this action. \n" +
                            "Missing Permission(s): " +
                            jqxhr.responseJSON.missing.join(", ") +
                            "\n\n" +
                            "Please contact an administrator if you believe that you should be allowed to perform this action."
                    );
                }

                console.log(jqxhr);
                window.location.href = "/";
            } else if (jqxhr.status == 401) {
                const source = (jqxhr as any)._source; 
                if (source === "topNavigation" || source === "leftNavigation" || source === "footer") return;
                
                if (this.lastView && !(this.lastView instanceof LoginView)) {
                    this.reauthenticate().catch(() => {
                        this._showLogin();
                    });
                }
            }
        });

        $.when(this.brandCollection.fetch()).done(() => {
            // Initialize basic views
            // Skip initial navigation render - will be rendered after user is loaded
            this.footerView = new FooterView({
                brandCollection: this.brandCollection,
            });

            $("#page").empty().append(this.spinnerTemplate());

            this.footerView.render();

            // Initialize routes
            this.on("route:logout", this.logout);

            // External Routes
            this.on("route:showForgotPassword", this._showForgotPassword);
            this.on("route:showAuthMigrate", this._showAuthMigrate);
            this.on("route:showJoinedGroup", this._showJoinedGroup);
            this.on("route:showJoinedOrganization", this._showJoinedOrganization);

            // Internal Routes
            this.on("route:showStatus", _.wrap(this._showStatus, this.requireLogin));
            this.on("route:showDashboard", _.wrap(this._showDashboard, this.requireLogin));
            this.on("route:showSettings", _.wrap(this._showSettings, this.requireLogin));
            this.on("route:showAccount", _.wrap(this._showAccount, this.requireLogin));
            this.on("route:showReports", _.wrap(this._showReports, this.requireLogin));
            this.on("route:showEditReports", _.wrap(this._showEditReports, this.requireLogin));
            this.on("route:showDailyReports", _.wrap(this._showDailyReports, this.requireLogin));
            this.on('route:showEditOrganizations', _.wrap(this._showEditOrganizations, this.requireLogin));
            this.on("route:showAddTools", _.wrap(this._showAddTools, this.requireLogin));
            this.on("route:showAddDashboard", _.wrap(this._showAddDashboard, this.requireLogin));
            this.on("route:profileRouteAlias", _.wrap(this._profileRouteAlias, this.requireLogin));

            this.on("route:landing", (orgId) => {
                // No collection loading
                this._goToFirstPage(orgId); 
            });
            
            this.on("route:root", () => {
                // Skip collection loading, go straight to landing
                this._goToFirstPage();
            });
            
            this.on("route:defaultAction", () => {
                const fragment = Backbone.history.getFragment();
            
                // If this is /landing/:orgId, let the landing route handle it
                if (fragment.startsWith("landing/")) return;
            
                // If collections are loaded and this route fired, the the route is nonexistent and we should
                // go to the page that makes the most sense
                if (this.collectionsLoaded) {
                    return this._goToFirstPage(); // fallback redirect
                }
            
                // If the collections are not loaded we load them and then try to navigate to the same url
                // since there could be new routes
                this.requireLogin(() => {
                    Backbone.history.navigate(Backbone.history.getFragment());
                    Backbone.history.loadUrl();
                });
            });
            

            this.on("route", function () {
                // Run route specific handlers first, including Intercom events etc. Then check if there are new messages
                // based on these events
                setTimeout(function () {
                    Intercom.update();
                }, 750);
            });

            Backbone.history.start();
        });

        // Detect unsupported browsers
        // See https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
        var isIE11 = !!(<any>window).MSInputMethodContext && !!(<any>document).documentMode;
        if (isIE11) {
            (<any>$).notify(
                {
                    icon: "fa fa-exclamation-triangle",
                    title: "Unsupported Browser",
                    message:
                        "Internet Explorer 11 is no longer supported. Your user experience may be degraded. " +
                        "Please update to a modern browser such as Google Chrome, Safari, or Microsoft Edge",
                },
                {
                    type: "warning",
                    delay: 0,
                    offset: {
                        x: 20,
                        y: 60,
                    },
                }
            );
        }
    }

    private renderNewNavView() {
        if (this.navView) this.navView.remove();
        if (this.sidepanelView) this.sidepanelView.remove();

        this.navView = new NavView({
            appCollection: this.appCollection,
            appRegistry: this.appRegistry,
            installCollection: this.installCollection,
            permissionCollection: this.permissionCollection,
            organizationCollection: this.organizationCollection,
            dashboardCollection: this.dashboardCollection,
            dashboardChannelCollection: this.dashboardChannelCollection,
            brandCollection: this.brandCollection,
            currentUser: this.currentUser,
        });
        $("nav").append(this.navView.render().$el);

        this.sidepanelView = new SidepanelView({
            appCollection: this.appCollection,
            appRegistry: this.appRegistry,
            installCollection: this.installCollection,
            permissionCollection: this.permissionCollection,
            organizationCollection: this.organizationCollection,
            dashboardCollection: this.dashboardCollection,
            dashboardChannelCollection: this.dashboardChannelCollection,
            brandCollection: this.brandCollection,
            currentUser: this.currentUser,
        });
        $("aside").append(this.sidepanelView.render().$el);
    }

    private registerApps() {
        if (!this.appRegistry) {
            this.appRegistry = new AppRegistry({
                appCollection: this.appCollection,
                appRegistry: null,
                installCollection: this.installCollection,
                permissionCollection: this.permissionCollection,
                organizationCollection: this.organizationCollection,
                dashboardCollection: this.dashboardCollection,
                dashboardChannelCollection: this.dashboardChannelCollection,
                brandCollection: this.brandCollection,
                currentUser: this.currentUser,
            });
        }

        // A list of deferreds of app modules that have yet to load
        var deferreds = [];

        var appTypes = _.keys(
            _.keyBy(this.appCollection.models, (m) => {
                return m.get("type");
            })
        );
        _.each(appTypes, (appType) => {
            var d = $.Deferred();
            deferreds.push(d);

            this.appRegistry.getInstance(appType, (err, app) => {
                // Register app specific routes
                _.each(app.getRoutes(), (func: (...args) => BaseAppView, route: string) => {
                    this.route(
                        appType + route,
                        appType,
                        _.wrap((...args) => {
                            // Clean up the previous view
                            if (this.lastView) this.lastView.remove();
                            this.lastView = func(...args);

                            // Create a new view
                            $("#page").empty().append(this.lastView.$el);
                            this.lastView.render();
                            App.Bus.trigger("setPageTitle", app.getAppName());
                        }, this.requireLogin)
                    );
                });
                d.resolve();
            });
        });

        return $.when.apply($, deferreds);
    }

    logout() {
        // Intercom logout
        Intercom.shutdown();

        Auth.signOut().then(() => {
            if (this.navView !== null) {
                this.navView.render();
            }
            setTimeout(() => {
                // we want to keep recent visits to dashboard and reports
                const savedRecentDashboards = localStorage.getItem("recentDashboards");
                const savedRecentReports = localStorage.getItem("recentReports");

                window.sessionStorage.clear();
                window.localStorage.clear();
                // re-save recent visits to dashboard and reports
                if (savedRecentDashboards) localStorage.setItem("recentDashboards", savedRecentDashboards);
                if (savedRecentReports) localStorage.setItem("recentReports", savedRecentReports);

                window.location.href = `https://${CONFIG.cognito.oauth.domain}/logout?client_id=${CONFIG.cognito.userPoolWebClientId}&logout_uri=${window.location.origin}`;
            }, 500);
        });
    }

    private getDefaultViewOptions() {
        return {
            appRegistry: this.appRegistry,
            appCollection: this.appCollection,
            brandCollection: this.brandCollection,
            installCollection: this.installCollection,
            permissionCollection: this.permissionCollection,
            organizationCollection: this.organizationCollection,
            dashboardCollection: this.dashboardCollection,
            dashboardChannelCollection: this.dashboardChannelCollection,
            currentUser: this.currentUser,
        };
    }

    private checkReplaceView(viewClass: typeof BaseView, options?: any) {
        if (this.lastView instanceof viewClass) return;

        if (this.lastView) (<BaseView>this.lastView).remove();
        this.lastView = new viewClass(options ? options : this.getDefaultViewOptions());
        $("#page").empty().append(this.lastView.$el);
    }

    private _showStatus(orgId, installId, moduleId) {
        this.checkReplaceView(StatusView);

        if (orgId == null) {
            var install = this.installCollection.first();
            if (!install) return this._showPermissionDenied();

            installId = install.get("id");
            orgId = install.get("organization_id");
            if (!orgId) orgId = null;
        }
        orgId = Number(orgId);

        if (installId == null) {
            var install = this.installCollection.findWhere({ organization_id: orgId });
            if (!install) return this._showPermissionDenied();

            installId = install.get("id");
        }
        installId = Number(installId);

        if (moduleId) moduleId = Number(moduleId);

        var App = (<any>window).App;
        App.Bus.trigger("switch:org", orgId);
        App.Bus.trigger("switch:install", installId, moduleId);
        App.Bus.trigger("setPageTitle", "System Status");

        (<StatusView>this.lastView).show(orgId, installId, moduleId);

        Intercom.trackEvent("viewed-system-status", {
            org_id: orgId,
            install_id: installId,
            module_id: moduleId,
        });
    }

    private _showSettings(subcategory, orgId, installId, moduleId) {
        this.checkReplaceView(SettingsView);

        if (orgId == null) {
            var install = this.installCollection.first();
            if (!install) return this._showPermissionDenied();

            installId = install.get("id");
            orgId = install.get("organization_id");
            if (!orgId) orgId = null;
        }
        orgId = Number(orgId);

        if (installId == null) {
            var install = this.installCollection.findWhere({ organization_id: orgId });
            if (!install) return this._showPermissionDenied();

            installId = install.get("id");
        }
        installId = Number(installId);

        if (subcategory == null) {
            subcategory = "install";
        }
        if (moduleId) moduleId = Number(moduleId);

        var App = (<any>window).App;
        App.Bus.trigger("switch:org", orgId);
        App.Bus.trigger("switch:install", installId, moduleId);
        App.Bus.trigger("setPageTitle", "Settings");

        (<SettingsView>this.lastView).show(orgId, installId, moduleId, subcategory);
    }

    private _showAccount(orgId, accountCategory, itemId, detail, subDetail, subDetailId) {
        this.checkReplaceView(AccountView);

        if (orgId == null) {
            var usergroups = this.currentUser.get("usergroups");

            if (!usergroups) return this._showPermissionDenied();

            //get first org id from user's usergroups if not supplied with one
            orgId = _.head(_.map(usergroups, "usergroup_organization_id"));
            if (!orgId) orgId = null;
        }
        orgId = Number(orgId);

        (<AccountView>this.lastView).show(orgId, accountCategory, itemId, detail, subDetail, subDetailId);
        App.Bus.trigger("account:switch:org", orgId);
        App.Bus.trigger("switch:install", null, null);
        App.Bus.trigger("switch:dashboard", null);
        App.Bus.trigger("setPageTitle", "Account");

        Intercom.trackEvent("viewed-test-account", {
            org_id: orgId,
        });
    }

    private _profileRouteAlias() {
        App.Bus.trigger("switch:install", null);
        App.Bus.trigger("switch:dashboard", null);
        App.Bus.trigger("setPageTitle", "Profile");

        Intercom.trackEvent("viewed-profile");

        var usergroups = this.currentUser.get("usergroups");
        if (!usergroups) return this._showPermissionDenied();

        var orgId = _.head(_.map(usergroups, "usergroup_organization_id"));
        if (!orgId) return this._showPermissionDenied();
        this.navigate("#/account/" + orgId + "/users/" + this.currentUser.get("id"));
    }

    private _showDashboard(dashboardId) {
        // Force navbar to re-render if there is no dashboard
        App.Bus.trigger("rerender:nav");

        this.checkReplaceView(DashboardView);
        if (dashboardId == null) {
            // Get most recent from sessionStorage (in case user has multiple tabs open)
            // Otherwise get from localstorage
            var sessionDashboard = sessionStorage.getItem("lastDashboardId");
            dashboardId = sessionDashboard ? sessionDashboard : localStorage.getItem("lastDashboardId");
            if (dashboardId && !this.permissionCollection.canViewDashboard(Number(dashboardId))) {
                dashboardId = null;
                sessionStorage.removeItem("lastDashboardId");
                localStorage.removeItem("lastDashboardId");
            }
        }

        var db;
        if (dashboardId == null) {
            db = this.dashboardCollection.first();
        } else {
            db = this.dashboardCollection.findWhere({ id: Number(dashboardId) });
        }

        if (!db) {
            return this._showPermissionDenied();
        } else {
            dashboardId = db.get("id");
            sessionStorage.setItem("lastDashboardId", String(dashboardId));
            localStorage.setItem("lastDashboardId", String(dashboardId));

            // Save this dashboard visit to localStorage for recent tracking
            this.saveDashboardVisit(dashboardId);
        }

        App.Bus.trigger("switch:org", db.get("organization_id"));
        App.Bus.trigger("switch:dashboard", dashboardId);
        App.Bus.trigger("setPageTitle", "Dashboard - " + db.get("name"));
        (<DashboardView>this.lastView).show(dashboardId);

        Intercom.trackEvent("viewed-dashboard", {
            dashboardId: dashboardId,
        });
    }

    /**
     * Saves the current dashboard visit to localStorage.
     * Keeps a list of the 5 most recently visited dashboards, each with ID, name, and timestamp.
     *
     * @param {string} dashboardId - The ID of the dashboard that was visited.
     */
    saveDashboardVisit(dashboardId) {
        const MAX_ENTRIES = 5;
        const STORAGE_KEY = "recentDashboards";

        const dashboardModel = this.dashboardCollection.findWhere({ id: Number(dashboardId) });
        const dashboardName = dashboardModel ? dashboardModel.get("name") : "Unknown Dashboard";
        const orgId = dashboardModel ? dashboardModel.get('organization_id') : 0;
        const visitedAt = new Date().toISOString();

        let visits = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");

        // Remove if it already exists (we'll re-add at the top)
        visits = visits.filter((item) => item.id !== dashboardId);

        visits.unshift({
            userId: this.currentUser.get("id"),
            id: dashboardId,
            orgId: orgId,
            name: dashboardName,
            visitedAt: visitedAt,
        });

        // Trim to max entries
        if (visits.length > MAX_ENTRIES) {
            visits = visits.slice(0, MAX_ENTRIES);
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify(visits));
    }

    private _showReports(orgId) {
        App.Bus.trigger("rerender:nav");

        this.checkReplaceView(ReportsView);

        if (orgId == null) {
            // Get most recent from sessionStorage (in case user has multiple tabs open)
            // Otherwise get from localstorage
            var sessionOrg = sessionStorage.getItem("lastOrgId");
            orgId = sessionOrg ? sessionOrg : localStorage.getItem("lastOrgId");
            if (orgId && !this.permissionCollection.canViewOrganization(Number(orgId))) {
                orgId = null;
                sessionStorage.removeItem("lastOrgId");
                localStorage.removeItem("lastOrgId");
            }
        }

        var org;
        if (orgId == null) {
            org = this.organizationCollection.first();
        } else {
            org = this.organizationCollection.findWhere({ id: Number(orgId) });
        }

        if (!org) {
            return this._showPermissionDenied();
        } else {
            orgId = org.get("id");
            sessionStorage.setItem("lastOrgId", String(orgId));
            localStorage.setItem("lastOrgId", String(orgId));
        }

        App.Bus.trigger("switch:org", orgId);
        App.Bus.trigger("switch:reportOrganizations", orgId);
        App.Bus.trigger("setPageTitle", "Reports - " + org.get("name"));
        (<ReportsView>this.lastView).show(Number(orgId));

        Intercom.trackEvent("viewed-reports", {
            orgId: orgId,
        });
    }

    private _showDailyReports(orgId) {
        App.Bus.trigger("rerender:nav");

        this.checkReplaceView(DailyReportsView);

        // Show Daily reports to only selected users belonging to specific organizations
        // List of allowed organizations:
        // 2   Attune
        // 364 Montgomery County Public Schools
        const orgsWithDailyReportAccess = [2, 364];
        const usergroups = this.currentUser.get("usergroups");
        let showDailyReports = false;
        for (const key in usergroups) {
            if (usergroups.hasOwnProperty(key)) {
                const usergroup = usergroups[key];
                if (orgsWithDailyReportAccess.includes(usergroup.usergroup_organization_id)) {
                    showDailyReports = true;
                    break;
                }
            }
        }

        if (!showDailyReports) {
            return this._showPermissionDenied();
        }

        App.Bus.trigger('switch:org', orgId);
        App.Bus.trigger('switch:reportOrganizations', orgId);
        App.Bus.trigger('setPageTitle', 'Daily Reports');
        (<DailyReportsView>this.lastView).show(Number(orgId));

        Intercom.trackEvent("viewed-daily-reports", {
            orgId: orgId,
        });
    }

    _showAddTools(toolType) {
        App.Bus.trigger("rerender:nav");

        this.checkReplaceView(AddToolsView);
        (<AddToolsView>this.lastView).show(toolType);
    }

    _showAddDashboard() {
        App.Bus.trigger("rerender:nav");

        this.checkReplaceView(AddDashboardView);
        (<AddDashboardView>this.lastView).show();
    }

    private _showEditOrganizations() {
        App.Bus.trigger('rerender:nav');

        this.checkReplaceView(EditOrganizationsView);

        if (!this.currentUser.isSensewareAdmin()) {
            return this._showPermissionDenied();
        }

        App.Bus.trigger('setPageTitle', 'Edit Organizations');
        (<EditOrganizationsView>this.lastView).show();

        Intercom.trackEvent('viewed-edit-organizations', {});
    }

    private _showEditReports(orgId, reportId, reportsEditCategory) {
        App.Bus.trigger("rerender:nav");

        this.checkReplaceView(EditReportsView);

        if (!reportsEditCategory) reportsEditCategory = "edit";

        if (orgId == null) {
            // Get most recent from sessionStorage (in case user has multiple tabs open)
            // Otherwise get from localstorage
            var sessionOrg = sessionStorage.getItem("lastOrgId");
            orgId = sessionOrg ? sessionOrg : localStorage.getItem("lastOrgId");
            if (orgId && !this.permissionCollection.canViewOrganization(Number(orgId))) {
                orgId = null;
                sessionStorage.removeItem("lastOrgId");
                localStorage.removeItem("lastOrgId");
            }
        }

        var org;
        if (orgId == null) {
            org = this.organizationCollection.first();
        } else {
            org = this.organizationCollection.findWhere({ id: Number(orgId) });
        }

        if (!org) {
            return this._showPermissionDenied();
        } else {
            orgId = org.get("id");
            sessionStorage.setItem("lastOrgId", String(orgId));
            localStorage.setItem("lastOrgId", String(orgId));
        }

        App.Bus.trigger("switch:org", org.get("organization_id"));
        App.Bus.trigger("switch:org", orgId);
        App.Bus.trigger("setPageTitle", "Reports - " + org.get("name"));
        (<EditReportsView>this.lastView).show(Number(orgId), Number(reportId), reportsEditCategory);

        Intercom.trackEvent("viewed-reports", {
            orgId: orgId,
            reportId: reportId,
        });
    }

    private _goToFirstPage(organizationId?) {
        const resolveOrgId = () => {
            if (organizationId) return organizationId;
    
            const usergroups = this.currentUser.get("usergroups");
            if (!usergroups) {
                this._showPermissionDenied();
                return null;
            }
    
            const orgId = _.head(_.map(usergroups, "usergroup_organization_id"));
            return orgId ?? "";
        };
    
        const redirectToLanding = (orgId) => {
            window.location.href = `/landing/${orgId}`;
        };
    
        this.currentUser = new CurrentUser();
        $.when(this.currentUser.fetch())
            .done(() => {
                const resolvedId = resolveOrgId();
                if (resolvedId !== null) redirectToLanding(resolvedId);
            })
            .fail(() => {
                this._showLogin();
            });
    }

    private _showLogin(errors?) {
        this.checkReplaceView(LoginView, {
            brandCollection: this.brandCollection,
        });
        (<LoginView>this.lastView).render(errors);
        App.Bus.trigger("setPageTitle", "Login");
    }

    private _showPermissionDenied() {
        this.checkReplaceView(PermissionDeniedView, {
            brandCollection: this.brandCollection,
        });
        this.lastView.render();
        App.Bus.trigger("setPageTitle", "Permission Denied");
    }

    private _showForgotPassword(userId, token) {
        this.checkReplaceView(ForgotPasswordView, {
            brandCollection: this.brandCollection,
            userId: userId,
            token: token,
        });
        this.lastView.render();
        App.Bus.trigger("setPageTitle", "Forgot Password");
    }

    private _showAuthMigrate(userId, token) {
        this.checkReplaceView(AuthMigrateView, {
            brandCollection: this.brandCollection,
            userId: userId,
            token: token,
        });
        this.lastView.render();
        App.Bus.trigger("setPageTitle", "Authentication");
    }

    private _showJoinedGroup(groupName) {
        this.checkReplaceView(InvitationAcceptedView, {
            brandCollection: this.brandCollection,
            groupName: groupName,
        });
        this.lastView.render();
        App.Bus.trigger("setPageTitle", "Invitation Accepted");
    }

    private _showJoinedOrganization(userId, token) {
        this.checkReplaceView(SetPasswordView, {
            brandCollection: this.brandCollection,
            userId: userId,
            token: token,
        });
        this.lastView.render();
        App.Bus.trigger("setPageTitle", "Sign-up");
    }

    onCollectionLoadFailure(collection, jqXHR) {
        if (jqXHR.status === 401) {
            this.reauthenticate().catch(() => {
                this._showLogin();
            });
        } else {
            console.log("503", jqXHR);
        }
    }

    IntercomLogin() {
        if (!this.brandCollection.getBrand().get("enableIntercom")) return;

        // Intercom Login
        var companies = _.map(this.currentUser.get("usergroups"), (usergroup) => {
            return {
                company_id: usergroup["usergroup_organization_id"],
                name: this.organizationCollection.findWhere({ id: usergroup["usergroup_organization_id"] }).get("name"),
            };
        });
        Intercom.boot(this.currentUser, companies);
        Intercom.trackEvent("logged-in");
        Intercom.update();
    }

    requireLogin(func, ...args) {
        if (!this.collectionsLoaded) {

            // We need to fetch user first, in order to be able to pass the current user when registering apps
            this.currentUser = new CurrentUser();
            $.when(this.currentUser.fetch())
                .done(() => {
                    // Update permission collection with current user reference for superuser checks
                    this.permissionCollection.currentUser = this.currentUser;
                    
                    var deferreds = [
                        this.organizationCollection.getCollectionFetchPromise(),
                        this.appCollection.getCollectionFetchPromise(),
                        this.dashboardCollection.getCollectionFetchPromise(),
                        this.installCollection.getCollectionFetchPromise(),
                        this.permissionCollection.getCollectionFetchPromise(),
                    ];

                    $.when
                        .apply($, deferreds)
                        .fail(() => {
                            console.log("Login Failed");
                        })
                        .done(() => {
                            this.IntercomLogin();
                            // Render navigation now that user is loaded (only once)
                            if (!this.navigationRendered) {
                                this.renderNewNavView();
                                this.navigationRendered = true;
                            }
                            // Trigger switch:user event for other components that need it
                            App.Bus.trigger("switch:user", this.currentUser);
                            $.when(this.registerApps()).done(() => {
                                this.collectionsLoaded = true;
                                func.apply(this, args);
                            });
                        });
                })
                .fail((jqXHR) => {
                    if (jqXHR.responseJSON && jqXHR.responseJSON.code === "UNKNOWNEMAILDOMAIN") {
                        // The user opted to sign in with SSO but the picked a wrong account
                        Auth.signOut().then(() => {
                            // we want to keep recent visits to dashboard and reports
                            const savedRecentDashboards = localStorage.getItem("recentDashboards");
                            const savedRecentReports = localStorage.getItem("recentReports");

                            localStorage.clear();

                            // re-save recent visits to dashboard and reports
                            if (savedRecentDashboards) localStorage.setItem("recentDashboards", savedRecentDashboards);
                            if (savedRecentReports) localStorage.setItem("recentReports", savedRecentReports);

                            sessionStorage.setItem(
                                "loginSSOError",
                                "This user is ineligible to sign in with SSO. Please sign in with your corporate account."
                            );
                            this._showLogin();
                        });
                    } else if (jqXHR.status === 401) {
                        this._showLogin();
                    } else {
                        console.log("503", jqXHR);
                    }
                });
        } else {
            func.apply(this, args);

            // Wait for the page to load, then update intercom
            setTimeout(function () {
                Intercom.update();
            }, 1000);

            // Refresh the jwt token every 15 minutes so that it doesn't expire
            if (this.jwtRefreshInterval) return;
            this.jwtRefreshInterval = setInterval(() => {
                Auth.currentAuthenticatedUser().then((u) => {
                    Auth.currentSession().then((s) => {
                        u.refreshSession(s.getRefreshToken(), () => {
                            console.log("Session refreshed");
                        });
                    });
                });
            }, 15 * 60 * 1000);
        }
    }

    /**
     * Attempts to refresh the current user's session using the stored refresh token.
     *
     * This is useful when a request fails with a 401 Unauthorized error, allowing
     * the app to recover the session without forcing the user to log in again.
     *
     * @returns {Promise<CognitoUserSession>} Resolves with the new session if successful, or rejects with an error.
     */
    reauthenticate() {
        return Auth.currentAuthenticatedUser()
            .then((user) => {
                return Auth.currentSession().then((session) => {
                    return new Promise((resolve, reject) => {
                        user.refreshSession(session.getRefreshToken(), (err, newSession) => {
                            if (err) {
                                console.error("Session refresh failed", err);
                                reject(err);
                            } else {
                                console.log("Session refreshed");
                                resolve(newSession);
                            }
                        });
                    });
                });
            })
            .catch((err) => {
                console.error("Failed to get current user/session", err);
                return Promise.reject(err);
            });
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/router.ts